/**
 * Storage for user details and company preference.
 */

import React, { useReducer, createContext } from "react";

export const UserContext = createContext();

const initialState = {
  userid:0,
  companyid:0,
  user:{}, //Stores user settings.
  default:{}, //Stores default settings.
  company:{}, //Stores company settings.

};


const reducer = (state, action) => {
  switch (action.type) {
    case "create":
      //console.log('Create user payload:'+JSON.stringify(action.payload));
      return { ...state, 
        userid: action.payload.userid,
        companyid: action.payload.companyid,
        user: action.payload.user,
        company: action.payload.company,
        default: action.payload.default,
      };

      case "updateuser":
        return { ...state, 
          user: action.payload.user,
      };
      case "end":
        //console.log('end payload:'+JSON.stringify(action.payload));
        return { ...state, 
          userid:0,
          companyid:0,
          user:{},
          default:{},
          company:{},
        };
      
    default:
      throw new Error();
  }
};

export const UserContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {props.children}
    </UserContext.Provider>
  );
};